import _ from "lodash"
import React from "react";
import ProjectReportsTableEmptyRow from "./components/ProjectReportsTableEmptyRow";
import ProjectReportsTableLoadingRow from "./components/ProjectReportsTableLoadingRow";
import ProjectReportsTableRow from "./components/ProjectReportsTableRow";
import StandardTable, { ThemedTableHeaderActionColumn } from "../../components/tables/StandardTable";
import { ClientReportProvider, useClientReportsList } from "../../hooks/ClientReportContext";
import { useClientProjectContext } from "../../hooks/ClientProjectContext";
import { NumericFormat } from "react-number-format";
import { AccordionSection, ThemedIcon, ThemedSpan } from "../../components/utilities";
import { IconButton } from "../../components";

// TODO: look at the on project changed part

export const ClientProjectsReportsTableAccordion = ({ label = "Reports" }) => {
    const { selectedValue: project } = useClientProjectContext();
    const { clear, data, newRecordsSinceCache, error, isNewRecords, isLoading, isUninitialized, showCreateModal } = useClientReportsList();
    return (
        <AccordionSection label={(
            <div className="d-flex w-100">
                <div className="flex-fill">{label}</div>
                {isNewRecords && (
                    <React.Fragment>
                        {newRecordsSinceCache > 1
                            ? (<ThemedSpan variant="danger" className="mx-2"><NumericFormat displayType="text" value={newRecordsSinceCache} thousandSeparator="," /> new records available.</ThemedSpan>)
                            : (<ThemedSpan variant="danger" className="mx-2"><NumericFormat displayType="text" value={newRecordsSinceCache} thousandSeparator="," /> new record available.</ThemedSpan>)
                        }
                        <ThemedIcon variant={isNewRecords ? 'danger' : 'muted'} icon="fas fa-sync" className="has-pointer mx-2" onClick={() => clear()} />)
                    </React.Fragment>
                )}
            </div>
        )} defaultActiveKey="1">
            <StandardTable 
                className="table-borderless table-sm"
                columns={[
                    { label: 'Name', property: 'reportName' },
                    { label: 'Status', property: 'statusDescription' },
                    { label: 'Author', property: 'authorName' },
                    { label: 'Compliance', property: 'complianceOfficerName' },
                    { label: 'Compliant', property: 'compliantDate' },
                    { label: 'Sent', property: 'sentDate' },
                    { label: 'Media', property: 'sentByMediaType' },
                    { label: 'Created', property: 'createdDate' },
                    { 
                        label: '', 
                        property: '',
                        headerRenderer: (props) => (
                            <ThemedTableHeaderActionColumn key={props.key}>
                                <IconButton className="btn-sm" icon="fa-plus" variant="success" onClick={showCreateModal} />
                            </ThemedTableHeaderActionColumn>
                        )
                    }
                ]}
                data={data}
                error={error}
                isLoading={isLoading || isUninitialized}
                isTableResponsive={false}
                EmptyRowComponent={ProjectReportsTableEmptyRow}
                emptyRowComponentProps={{ onCreateClicked: showCreateModal }}
                hideHeaderOnEmpty={true}
                LoadingRowComponent={ProjectReportsTableLoadingRow}
                RowComponent={ProjectReportsTableRow}
                rowComponentProps={{ project }}
            />
        </AccordionSection>
    );
};

const ClientProjectsReportsTable = ({ onProjectChanged = () => {} }) => {
    const { selectedValue } = useClientProjectContext();
    
    if (!selectedValue) {
        return null;
    }

    const { masterAccountId, projectId } = selectedValue;
    return (
        <React.Fragment>
            <ClientReportProvider masterAccountId={masterAccountId} projectId={projectId}>
                <ClientProjectsReportsTableAccordion />
            </ClientReportProvider>            
        </React.Fragment>
    )
};

export default ClientProjectsReportsTable;